import { put } from "redux-saga/effects";
import http from "~/utils/config/http";

import { activeSuccess, activeError } from "~/components/Messages/actions";

import * as types from "./actionTypes";
import * as middlewares from "~/utils/constants";

export function* pullDataFromBPM() {
  try {
    const resp =yield http.get("/api/middleware/pull-data", middlewares.BPM_MIDDLEWARE);
    yield put(types.setPulledDataFromBPM(true));
    yield put(activeSuccess(resp.data.message));
  } catch (e) {
    yield put(types.setPulledDataFromBPM(false));
    yield put(activeError("admin.applications.bpm.errorPulledMessage"));
  }
}

export function* pullDataAllMiddleware() {
  try {
    const resp =yield http.get("/api/middleware/pull-data-all-middleware", middlewares.BPM_MIDDLEWARE);
    yield put(types.setPulledAllMiddleware(true));
    yield put(activeSuccess(resp.data.message));
  } catch (e) {
    console.log(e);
    yield put(types.setPulledAllMiddleware(false));
    yield put(activeError("admin.applications.bpm.errorPulledMessage"));
  }
}

export function* pingMiddlewareApplication({ middleware }) {
  try {
    yield http.get("/api/open/about", middleware);
    yield put(types.setPingMiddlewareApplication({ middleware, status: true }));
  } catch (e) {
    yield put(
      types.setPingMiddlewareApplication({ middleware, status: false })
    );
  }
}

export function* pingIFlowBasedApplication({ payload }) {
  const { url, application } = payload;
  try {
    yield http.get(url, application);
    yield put(
      types.setPingIFlowBasedApplication({ application, status: true })
    );
  } catch (e) {
    yield put(
      types.setPingIFlowBasedApplication({ application, status: false })
    );
  }
}
